import { useAppDispatch, useAppSelector } from "app/hooks";
import { getContainers } from "app/reducers/containersSlice";
import { fetchContainers } from "app/thunks/containersAPI";
import { forwardRef, useEffect, useMemo } from "react";

import Select, { Props as SelectProps } from "./Select";

type Props = Omit<SelectProps, "options">;

const ContainerSelect = forwardRef<HTMLButtonElement, Props>(
  ({ ...props }: Props, ref) => {
    const dispatch = useAppDispatch();
    const { containers } = useAppSelector(getContainers);

    useEffect(() => {
      dispatch(fetchContainers());
    }, [dispatch]);

    const containersOptions = useMemo(() => {
      return containers
        ? containers.map((container) => ({
            value: container._id,
            label: `Contenedor #${container.number}`,
          }))
        : [];
    }, [containers]);

    return (
      <Select
        {...props}
        ref={ref}
        placeholder="Seleccionar..."
        options={containersOptions}
      />
    );
  },
);

ContainerSelect.displayName = "ContainerSelect";

export default ContainerSelect;
